import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import axiosInstance from "../utils/AxiosInstance";
import { AppContext } from "../context/AppContext";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { useMsal } from "@azure/msal-react";
import { getActivityActor } from "../utils/activityActor";

const AddDataModal = ({
  isOpen,
  onClose,
  fetchData,
  setCurrentPage,currentPage,
  searchTerm,
  fetchWorkspaces,
  fetchPipelines,
  fetchTableReports,
  fetchExistingReport,
  fetchFieldTable,
  fetchValueField,
  isEditMode,
  fetchWorkspacesReports,
  fetchViewerEmail,fetchViewerEmailTitle,
  setIsEditMode,
  ValueField,
  editDataExisting,
  setShowModal,
  tableReport,
  fetchAllReports,
}) => {
  const {
    setLoader,
    setToast,
    workspaces,
    viewerEmails,
   emailOptionTitle,
    fieldTable,
    pipelines,
    workSpaceReports,
    selectedWorkspace,
    setSelectedWorkspace,
    selectedReport,
    setSelectedReport,
    selectedPipeline,
    setSelectedPipeline,
    selectedTable,
    setselectedTable,
    selSelectedTableData,
    selectedField,
    selectedTableData,
    setSelectedField,
    userId,
    selectedValue,
    setSelectedValue,
    setUserId,
    reportOptions,
    selectedRoles,
    setSelectedRoles,
    selectedReportTitle,
    setSelectedReportTitle,
    rlsType,
    setRlsType,
    setApplicationOption,
    ApplicationOption,reportId:reportIds
  } = useContext(AppContext);

  const [editData, setEditData] = useState(editDataExisting || null);
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const actor = getActivityActor(account);
  const [reportId, setReportId] = useState(null);
  // const [rlsType, setRlsType] = useState("report");
  const [showPipelineWorkspace, setShowPipelineWorkspace] = useState(true);
  const isHydrating = useRef(false);
  const lastFetched = useRef({
    pipelineFor: null,
    workspacesFor: null,
    reportsFor: null,
    tablesFor: null,
    fieldsFor: null,
    valuesFor: null,
  });
// useEffect(() => {
//   if (editDataExisting) {
//     setEditData(editDataExisting);
//   }
// }, [editDataExisting]);

  const EmailOptions = useMemo(
    () =>
      Array.isArray(viewerEmails)
        ? viewerEmails.map((email) => ({
            label: email?.email,
            value: email?.email,
          }))
        : [],
    [viewerEmails]
  );
  const EmailOptionsforApplication = useMemo(
    () =>
      Array.isArray(emailOptionTitle)
        ? emailOptionTitle.map((email) => ({
            label: email?.email,
            value: email?.email,
          }))
        : [],
    [emailOptionTitle]
  );


  const valueOptions = useMemo(
    () =>
      Array.isArray(ValueField)
        ? ValueField.map((item) => ({
            label: item.GROUP_3,
            value: item.GROUP_3,
          }))
        : [],
    [ValueField]
  );

  const tables = useMemo(() => {
    if (Array.isArray(tableReport?.table)) {
      return tableReport.table.map((t) => ({
        label: t.lable || t.label || t.value || t,
        value: t.value || t,
      }));
    }
    if (tableReport?.table && typeof tableReport.table === "object") {
      return [
        {
          label:
            tableReport.table.lable ||
            tableReport.table.label ||
            tableReport.table.value,
          value: tableReport.table.value,
        },
      ];
    }
    return [];
  }, [tableReport]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    control,
    watch,
  } = useForm({
    defaultValues: {
      EMAIL: "",
      pipeline: null,
      workspace: null,
      report: null,
      table: null,
      field: null,
      value: [],
      DISTRIBUTION_CLIENT: "",
      USER_NAME: "",
      USER_ID: "",
      LOCATION: "",
      // STATUS: "1",
      COMMENTS: "",
    },
  });

  useEffect(() => {
    if(!isEditMode){
  fetchViewerEmail?.();
    fetchViewerEmailTitle?.()
    }
    // fetchPipelines?.();
    // fetchAllReports?.()
  }, []);

  const email = watch("EMAIL");
  const selectedReportId = watch("report") || selectedReport;
  const selectedPipelineValue = watch("pipeline");
  const selectedreportTitleValue = watch("reportTitle");
  const selectedWorkspaceValue = watch("workspace");

  const checkExisting = async (email, report) => {
    if (!email || !report?.id) return;
    try {
      const payload = {
        EMAIL: email,
        REPORT_ID: report.id,
      };
      const response = await axiosInstance.post(
        "/check-existing-data",
        payload
      );

      if (response.data) {
        setIsEditMode(true);
        setEditData(response.data);


        // const reportTitleObj=response.data.REPORT_TITLE?.[0] || null
        const reportTitleObj = response.data.REPORT_TITLE?.[0] || null;

     

        const pipelineObj = response.data.PIPELINE?.[0] || null;
        const workspaceObj = response.data.WORKSPACE?.[0] || null;
        const reportObj = response.data.REPORT?.[0] || null;
        const tableStr = response.data.TABLE || null;
        const columnStr = response.data.COLUMN || null;
        const valueStr = response.data.VALUE || "";

        const valueArr = valueStr
          ? valueStr
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
          : [];
        const selectedValues = valueArr.map((v) => ({ id: v, name: v }));

        reset({
          DISTRIBUTION_CLIENT: response.data.DISTRIBUTION_CLIENT || "",
          USER_NAME: response.data.USER_NAME || "",
          EMAIL: response.data.EMAIL || "",
          USER_ID: response.data.USER_ID || "",
          LOCATION: response.data.LOCATION || "",
          // STATUS: String(response.data.STATUS ?? ""),
          COMMENTS: response.data.COMMENTS || "",
          reportTitle: reportTitleObj
            ? { id: reportTitleObj.id, name: reportTitleObj.name }
            : selectedreportTitleValue,
          pipeline: pipelineObj
            ? { id: pipelineObj.id, name: pipelineObj.name }
            : selectedPipelineValue,
          workspace: workspaceObj
            ? { id: workspaceObj.id, name: workspaceObj.name }
            : selectedWorkspaceValue,
          report: reportObj
            ? { id: reportObj.id, name: reportObj.name }
            : report,
          table: tableStr ? { id: tableStr, name: tableStr } : null,
          field: columnStr ? { id: columnStr, name: columnStr } : null,
          value: selectedValues,
        });

        setSelectedPipeline(
          pipelineObj
            ? { id: pipelineObj.id, name: pipelineObj.name }
            : selectedPipeline
        );
        setSelectedWorkspace(
          workspaceObj
            ? { id: workspaceObj.id, name: workspaceObj.name }
            : selectedWorkspace
        );
        setSelectedReport(
          reportObj
            ? { id: reportObj.id, name: reportObj.name }
            : selectedReportTitle
        );
        setselectedTable(tableStr ? { id: tableStr, name: tableStr } : null);
        setSelectedField(columnStr ? { id: columnStr, name: columnStr } : null);
        setSelectedValue(selectedValues);

        isHydrating.current = true;
        try {
          if (
            reportTitleObj?.id &&
            lastFetched.current.pipelineFor !== reportTitleObj.id
          ) {
            await fetchPipelines?.(reportTitleObj.id);
            lastFetched.current.pipelineFor = reportTitleObj.id;
          }
          if (
            pipelineObj?.id &&
            lastFetched.current.workspacesFor !== pipelineObj.id
          ) {
            await fetchWorkspaces?.(pipelineObj.id);
            lastFetched.current.workspacesFor = pipelineObj.id;
          }
          if (
            workspaceObj?.id &&
            lastFetched.current.reportsFor !== workspaceObj.id
          ) {
            await fetchWorkspacesReports?.(workspaceObj.id);
            lastFetched.current.reportsFor = workspaceObj.id;
          }
          if (
            workspaceObj?.id &&
            reportObj?.id &&
            lastFetched.current.tablesFor !==
              `${workspaceObj.id}:${reportObj.id}`
          ) {
            await fetchTableReports?.({
              WORKSPACE_ID: workspaceObj.id,
              REPORT_ID: reportObj.id,
            });
            lastFetched.current.tablesFor = `${workspaceObj.id}:${reportObj.id}`;
          }
          if (tableStr && lastFetched.current.fieldsFor !== tableStr) {
            await fetchFieldTable?.(tableStr);
            lastFetched.current.fieldsFor = tableStr;
          }
          if (columnStr && lastFetched.current.valuesFor !== columnStr) {
            await fetchValueField?.(columnStr);
            lastFetched.current.valuesFor = columnStr;
          }
        } finally {
          setTimeout(() => {
            isHydrating.current = false;
          }, 0);
        }
      }
    } catch (err) {
      if (err.response?.status === 404) {
        setIsEditMode(false);
        setEditData(null);
        reset({
          DISTRIBUTION_CLIENT: "",
          USER_NAME: "",
          EMAIL: email || "",
          USER_ID: userId || "",
          LOCATION: "",
          // STATUS: "",
          COMMENTS: "",
          reportTitle: selectedreportTitleValue || null,
          pipeline: selectedPipelineValue || null,
          workspace: selectedWorkspaceValue || null,
          report: report || null,
          table: null,
          field: null,
          value: [],
        });
      } else {
        console.error("Check existing error:", err);
      }
    }
  };

  useEffect(() => {
    if (email) {
      const id = email.split("@")[0];
      setUserId(id);
      setValue("USER_ID", id);
    }
  }, [email, setUserId, setValue]);

  useEffect(() => {
    if (!isEditMode || !editDataExisting) return;

    isHydrating.current = true;

    const e = editDataExisting;
    setEditData(e);

    const defaults = {
      DISTRIBUTION_CLIENT: e.DISTRIBUTION_CLIENT || "",
      USER_NAME: e.USER_NAME || "",
      EMAIL: e.EMAIL || "",
      USER_ID: e.USER_ID || "",
      LOCATION: e.LOCATION || "",
      // STATUS: typeof e.STATUS === "number" ? String(e.STATUS) : (e.STATUS || ""),
      COMMENTS: e.COMMENTS || "",
    };

    const pipelineObj = e.PIPELINE?.[0] || null;
    // const reportTitleObj = e.REPORT_TITLE?.[0] || null;
    const reportTitleStr = e.REPORT_TITLE || null;
    const workspaceObj = e.WORKSPACE?.[0] || null;
    const reportObj = e.REPORT?.[0] || null;
    const tableStr = e.TABLE || null;
    const columnStr = e.COLUMN || null;
    const valueStr = e.VALUE || "";
    const reportTitleObj = reportTitleStr
      ? { id: reportTitleStr, name: reportTitleStr }
      : null;
    const valueArr = valueStr
      ? valueStr
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
      : [];
    const selectedValues = valueArr.map((v) => ({ id: v, name: v }));
    if (rlsType === "application" && !pipelineObj) {
      setShowPipelineWorkspace(false);
    } else {
      setShowPipelineWorkspace(true);
    }
    reset({
      ...defaults,
      pipeline: pipelineObj
        ? { id: pipelineObj.id, name: pipelineObj.name }
        : null,
      // reportTitle: reportTitleObj ? { id: reportTitleObj.id, name: reportTitleObj.name } : null,
      reportTitle: reportTitleObj,
      workspace: workspaceObj
        ? { id: workspaceObj.id, name: workspaceObj.name }
        : null,
      report: reportObj ? { id: reportObj.id, name: reportObj.name } : null,
      table: tableStr ? { id: tableStr, name: tableStr } : null,
      field: columnStr ? { id: columnStr, name: columnStr } : null,
      value: selectedValues,
    });
    setSelectedReportTitle(reportTitleObj);
    // setSelectedReportTitle(reportTitleObj ? { id: reportTitleObj.id, name: reportTitleObj.name } : null);
    setSelectedPipeline(
      pipelineObj ? { id: pipelineObj.id, name: pipelineObj.name } : null
    );
    setSelectedWorkspace(
      workspaceObj ? { id: workspaceObj.id, name: workspaceObj.name } : null
    );
    setSelectedReport(
      reportObj ? { id: reportObj.id, name: reportObj.name } : null
    );
    setselectedTable(tableStr ? { id: tableStr, name: tableStr } : null);
    setSelectedField(columnStr ? { id: columnStr, name: columnStr } : null);
    setSelectedValue(selectedValues);

    (async () => {
      try {
        if (
          reportTitleObj?.id &&
          lastFetched.current.pipelineFor !== reportTitleObj.id
        ) {
          await fetchPipelines?.(reportTitleObj.id);
          lastFetched.current.pipelineFor = reportTitleObj.id;
        }
        if (
          pipelineObj?.id &&
          lastFetched.current.workspacesFor !== pipelineObj.id
        ) {
          await fetchWorkspaces?.(pipelineObj.id);
          lastFetched.current.workspacesFor = pipelineObj.id;
        }
        if (
          workspaceObj?.id &&
          lastFetched.current.reportsFor !== workspaceObj.id
        ) {
          await fetchWorkspacesReports?.(workspaceObj.id);
          lastFetched.current.reportsFor = workspaceObj.id;
        }
        if (
          workspaceObj?.id &&
          reportObj?.id &&
          lastFetched.current.tablesFor !== `${workspaceObj.id}:${reportObj.id}`
        ) {
          await fetchTableReports?.({
            WORKSPACE_ID: workspaceObj.id,
            REPORT_ID: reportObj.id,
          });
          lastFetched.current.tablesFor = `${workspaceObj.id}:${reportObj.id}`;
        }
        if (tableStr && lastFetched.current.fieldsFor !== tableStr) {
          await fetchFieldTable?.(tableStr);
          lastFetched.current.fieldsFor = tableStr;
        }
        if (columnStr && lastFetched.current.valuesFor !== columnStr) {
          await fetchValueField?.(columnStr);
          lastFetched.current.valuesFor = columnStr;
        }
      } finally {
        setTimeout(() => {
          isHydrating.current = false;
        }, 0);
      }
    })();
  }, [isEditMode, editDataExisting]);

  useEffect(() => {
    if (isHydrating.current) return;
    const pipelineId = selectedPipeline?.id;
    if (!pipelineId) return;
    if (lastFetched.current.workspacesFor === pipelineId) return;
    lastFetched.current.workspacesFor = pipelineId;
    fetchWorkspaces?.(pipelineId);
  }, [selectedPipeline, fetchWorkspaces]);

  useEffect(() => {
    if (isHydrating.current) return;
    const workspaceId = selectedWorkspace?.id;
    if (!workspaceId) return;
    if (lastFetched.current.reportsFor === workspaceId) return;
    lastFetched.current.reportsFor = workspaceId;
    fetchWorkspacesReports?.(workspaceId);
  }, [selectedWorkspace, fetchWorkspacesReports]);

  useEffect(() => {
    if (isHydrating.current) return;
    const wsId = selectedWorkspace?.id;
    const repId = selectedReport?.id;
    if (!wsId || !repId) return;
    const key = `${wsId}:${repId}`;
    if (lastFetched.current.tablesFor === key) return;
    lastFetched.current.tablesFor = key;
    fetchTableReports?.({ WORKSPACE_ID: wsId, REPORT_ID: repId });
  }, [selectedWorkspace, selectedReport, fetchTableReports]);

  useEffect(() => {
    if (isHydrating.current) return;
    const tableId = selectedTable?.id;
    if (!tableId) return;
    if (lastFetched.current.fieldsFor === tableId) return;
    lastFetched.current.fieldsFor = tableId;
    fetchFieldTable?.(tableId);
  }, [selectedTable, fetchFieldTable]);

  useEffect(() => {
    if (isHydrating.current) return;
    const columnId = selectedField?.id;
    if (!columnId) return;
    if (lastFetched.current.valuesFor === columnId) return;
    lastFetched.current.valuesFor = columnId;
    fetchValueField?.(columnId);
  }, [selectedField, fetchValueField]);

  const findOption = (options, id) =>
    options?.find((o) => o.value === id) || null;

  const onSubmit = async (data) => {
    setLoader(true);
    const isApplication = rlsType === "application";
    const payload = {
      //  REPORT_TITLE: data?.reportTitle?.name ?? "",
      REPORT_TITLE: data?.reportTitle?.name ?? "",
      DISTRIBUTION_CLIENT: data.DISTRIBUTION_CLIENT,
      USER_NAME: data.USER_NAME,
      EMAIL: data.EMAIL,
      LOCATION: data.LOCATION,
      USER_ID: data.USER_ID,
      PIPELINE: isApplication
        ? [{ id: null, name: null }]
        : data.pipeline
        ? [{ id: data.pipeline.id, name: data.pipeline.name }]
        : [],
      WORKSPACE: isApplication
        ? [{ id: null, name: null }]
        : data.workspace
        ? [{ id: data.workspace.id, name: data.workspace.name }]
        : [],
    REPORT: isApplication
  ? data.report
    ? [{ id: data.report.id, name: data.report.name }]
    : []
  : data.report
  ? [{ id: data.report.id, name: data.report.name }]
  : [],

      // PIPELINE: data.pipeline ? [{ id: data.pipeline.id, name: data.pipeline.name }] : [],
      // WORKSPACE: data.workspace ? [{ id: data.workspace.id, name: data.workspace.name }] : [],
      // REPORT: data.report ? [{ id: data.report.id, name: data.report.name }] : [],
      TABLE: data.table?.id || data.table?.name || "BIL_BOOKATTRIBUTES",
      COLUMN: data.field?.id || data.field?.name || "GROUP_3",
      VALUE: Array.isArray(data.value)
        ? data.value.map((v) => v.name).join(",")
        : data.value?.name || data.value || "",
      // STATUS: Number(data.STATUS),
      COMMENTS: data.COMMENTS,
      ...actor,
    };

    try {
      const response = await axiosInstance.post("/data", payload);
      if (response.status === 200) {
        setToast({
          show: true,
          type: "success",
          message: response?.data?.message || "User created successfully",
        });
        // setCurrentPage(currentPage);
        fetchData({ searchTerm, page: currentPage});
        handleClose();
        reset();
        return;
      }
    } catch (error) {
      if (error.response?.status === 409 && error.response?.data) {
        const existingUser = error.response.data;
        const userObj = existingUser.data[0];
        setIsEditMode(true);
        setEditData(existingUser.data);
        setShowModal(true);

        const pipelineObj = existingUser.PIPELINE?.[0] || null;
        const reportTitle = existingUser.REPORT_TITLE?.[0] || null;
        const workspaceObj = existingUser.WORKSPACE?.[0] || null;
        const reportObj = existingUser.REPORT?.[0] || null;
        const tableStr = existingUser.TABLE || null;
        const columnStr = existingUser.COLUMN || null;
        const valueStr = userObj.VALUE || "";

        const valueArr = valueStr
          ? valueStr
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
          : [];
        const selectedValues = valueArr.map((v) => ({ id: v, name: v }));

        reset({
          DISTRIBUTION_CLIENT: userObj.DISTRIBUTION_CLIENT || "",
          USER_NAME: userObj.USER_NAME || "",
          EMAIL: userObj.EMAIL || "",
          USER_ID: userObj.USER_ID || "",
          LOCATION: userObj.LOCATION || "",
          // STATUS: String(userObj.STATUS ?? ""),
          COMMENTS: userObj.COMMENTS || "",
          reportTitle: reportTitle
            ? { id: reportTitle.id, name: reportTitle.name }
            : selectedreportTitleValue,
          pipeline: pipelineObj
            ? { id: pipelineObj.id, name: pipelineObj.name }
            : selectedPipelineValue,
          workspace: workspaceObj
            ? { id: workspaceObj.id, name: workspaceObj.name }
            : selectedWorkspaceValue,
          report: reportObj
            ? { id: reportObj.id, name: reportObj.name }
            : selectedReportId,
          table: tableStr ? { id: tableStr, name: tableStr } : null,
          field: columnStr ? { id: columnStr, name: columnStr } : null,
          value: selectedValues,
        });
        //  setSelectedReportTitle(reportTitle ? { id: reportTitle.id, name: reportTitle.name } : selectedPipeline);
        setSelectedReportTitle(
          reportTitle
            ? { id: reportTitle.id, name: reportTitle.name }
            : selectedReportTitle
        );
        setSelectedPipeline(
          pipelineObj
            ? { id: pipelineObj.id, name: pipelineObj.name }
            : selectedPipeline
        );
        setSelectedWorkspace(
          workspaceObj
            ? { id: workspaceObj.id, name: workspaceObj.name }
            : selectedWorkspace
        );
        setSelectedReport(
          reportObj
            ? { id: reportObj.id, name: reportObj.name }
            : selectedReport
        );
        setselectedTable(tableStr ? { id: tableStr, name: tableStr } : null);
        setSelectedField(columnStr ? { id: columnStr, name: columnStr } : null);
        setSelectedValue(selectedValues);

        isHydrating.current = true;
        try {
          if (
            workspaceObj?.id &&
            lastFetched.current.reportsFor !== workspaceObj.id
          ) {
            await fetchWorkspacesReports(workspaceObj.id);
            lastFetched.current.reportsFor = workspaceObj.id;
          }
          if (
            workspaceObj?.id &&
            reportObj?.id &&
            lastFetched.current.tablesFor !==
              `${workspaceObj.id}:${reportObj.id}`
          ) {
            await fetchTableReports({
              WORKSPACE_ID: workspaceObj.id,
              REPORT_ID: reportObj.id,
            });
            lastFetched.current.tablesFor = `${workspaceObj.id}:${reportObj.id}`;
          }
          if (tableStr && lastFetched.current.fieldsFor !== tableStr) {
            await fetchFieldTable(tableStr);
            lastFetched.current.fieldsFor = tableStr;
          }
          if (columnStr && lastFetched.current.valuesFor !== columnStr) {
            await fetchValueField(columnStr);
            lastFetched.current.valuesFor = columnStr;
          }
        } finally {
          setTimeout(() => (isHydrating.current = false), 0);
        }

        setToast({
          show: true,
          type: "info",
          message:
            "User already exists. You can edit and update the record here.",
        });

        setLoader(false);
        return;
      }

      setToast({
        show: true,
        type: "error",
        message: error.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoader(false);
    }
  };

  const onUpdate = async (data) => {
    const id =
      editData?.DOCUMENT_ID ||
      editData?.[0]?.DOCUMENT_ID ||
      editDataExisting?.DOCUMENT_ID ||
      "";

    setLoader(true);
    const isApplication = rlsType === "application";
    const payload = {
      REPORT_TITLE: data?.reportTitle.name,
      DISTRIBUTION_CLIENT: data.DISTRIBUTION_CLIENT,
      USER_NAME: data.USER_NAME,
      EMAIL: data.EMAIL,
      LOCATION: data.LOCATION,
      USER_ID: data.USER_ID,
      PIPELINE: isApplication
        ? [{ id: null, name: null }]
        : data.pipeline
        ? [{ id: data.pipeline.id, name: data.pipeline.name }]
        : editData?.PIPELINE || [],
      WORKSPACE: isApplication
        ? [{ id: null, name: null }]
        : data.workspace
        ? [{ id: data.workspace.id, name: data.workspace.name }]
        : editData?.WORKSPACE || [],
    REPORT: isApplication
  ? data.report
    ? [{ id: data.report.id, name: data.report.name }]
    : []
  : data.report
  ? [{ id: data.report.id, name: data.report.name }]
  : [],
      // PIPELINE: data.pipeline ? [{ id: data.pipeline.id, name: data.pipeline.name }] : editData?.PIPELINE || [],
      // WORKSPACE: data.workspace ? [{ id: data.workspace.id, name: data.workspace.name }] : editData?.WORKSPACE || [],
      // REPORT: data.report ? [{ id: data.report.id, name: data.report.name }] : editData?.REPORT || [],
      TABLE:
        data.table?.id ||
        data.table?.name ||
        editData?.TABLE ||
        "BIL_BOOKATTRIBUTES",
      COLUMN:
        data.field?.id || data.field?.name || editData?.COLUMN || "GROUP_3",
      VALUE: Array.isArray(data.value)
        ? data.value.map((v) => v.name).join(",")
        : data.value?.name || data.value || editData?.VALUE || "",
      // STATUS: Number(data.STATUS),
      COMMENTS: data.COMMENTS,
      DOCUMENT_ID: id,
      ...actor,
    };

    try {
      const response = await axiosInstance.put("/data", payload);
      if (response.status === 200) {
        setToast({
          show: true,
          type: "success",
          message: response?.data?.message || "User updated successfully",
        });
        fetchData({ searchTerm, page: currentPage });
      handleClose();
      reset();
        // setCurrentPage(currentPage);
        // fetchData({ searchTerm, page: currentPage });
        // handleClose();
        // reset();
      }
    } catch (error) {
      setToast({
        show: true,
        type: "error",
        message: error.response?.data?.message || "Update failed",
      });
    } finally {
      setLoader(false);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setIsEditMode(false);
    setSelectedWorkspace(null);
    setSelectedPipeline(null);
    setSelectedReportTitle(null);
    setSelectedReport(null);
    setselectedTable(null);
    setSelectedField(null);
    setSelectedValue(null);
    setUserId("");
    reset({
      EMAIL: "",
      pipeline: null,
      workspace: null,
      report: null,
      table: null,
      field: null,
      value: [],
      DISTRIBUTION_CLIENT: "",
      USER_NAME: "",
      USER_ID: "",
      LOCATION: "",
      // STATUS: "",
      COMMENTS: "",
      reportTitle: "",
    });
    onClose?.();
  };

  const watchedField = watch("field");
  useEffect(() => {
    const fetchReportDetails = async () => {
      try {
        const response = await axiosInstance.post("/getReportDetails", {
          id: reportId,
        });

        if (response.data.success) {
          const { pipeline, workspace, report } = response.data.report;

          setValue("pipeline", pipeline);
          setValue("workspace", workspace);
          setValue("report", report);

          setSelectedPipeline(pipeline);
          setSelectedWorkspace(workspace);
          setSelectedReport(report);
        }
if (response?.data?.report?.report) {
  const reportInfo = response.data.report.report; 
  setValue("reportName", { id: reportInfo.id, name: reportInfo.name });
}

      } catch (err) {
        console.error("Error fetching report details:", err);
      }
    };

    if (reportId) {
      fetchReportDetails();
    }
  }, [reportId, setValue]);
  useEffect(() => {
    if (selectedReport?.name && !isEditMode) {
      setValue("COMMENTS", selectedReport.name, { shouldValidate: true });
    }
  }, [selectedReport, setValue]);
  useEffect(() => {
    console.log(editData,editDataExisting,'editdata12345')
  }, [rlsType, editData]);
  const options = rlsType === "report" ? reportOptions : reportIds;

  return (
    //  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 max-h-screen overflow-y-auto">
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 ">
       <div className="relative bg-white rounded-lg shadow-lg w-[95%] max-w-5xl max-h-[98vh] overflow-y-auto p-6 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
       {/* <div className="bg-white p-6 rounded-lg shadow-lg w-[95%] max-w-5xl relative">  */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-xl font-bold mt-4"
          aria-label="Close"
        >
          &times;
        </button>
{/* <div className="sticky mt-0 bg-white z-[999] top-0 w-full h-[60px]"> */}
        <h2 className="  md:text-2xl text-[15px] font-semibold mb-6 text-center">
          {isEditMode ? "Edit User" : "Add New User"}
        </h2>

{/* </div> */}
        {!isEditMode && (
  <div className="md:col-span-2 flex items-center gap-6 mt-4 mb-4">
    <label className="text-sm font-medium">Type:</label>

    <label className="flex items-center gap-2 cursor-pointer">
      <input
        type="radio"
        name="rlsType"
        value="report"
        checked={rlsType === "report"}
        onChange={(e) => {
          setRlsType(e.target.value);
          setValue("pipeline", null);
          setValue("workspace", null);
          setValue("report", null);
          setValue("table", null);
          setValue("field", null);
          setValue("value", null);
          setValue("DISTRIBUTION_CLIENT", null);
          setValue("COMMENTS", null);
          setValue("LOCATION", null);
          setValue("USER_NAME", null);
          setValue("EMAIL", null);
          setValue("USER_ID", null);
          setValue("reportTitle", null);
          setValue("reportName", null);
        }}
      />
      <span>Report</span>
    </label>

    <label className="flex items-center gap-2 cursor-pointer">
      <input
        type="radio"
        name="rlsType"
        value="application"
        checked={rlsType === "application"}
        onChange={(e) => {
          setRlsType(e.target.value);
          setValue("pipeline", null);
          setValue("workspace", null);
          setValue("report", null);
          setValue("table", null);
          setValue("field", null);
          setValue("value", null);
          setValue("DISTRIBUTION_CLIENT", null);
          setValue("COMMENTS", null);
          setValue("LOCATION", null);
          setValue("USER_NAME", null);
          setValue("EMAIL", null);
          setValue("USER_ID", null);
          setValue("reportTitle", null);
          setValue("reportName", null);
        }}
      />
      <span>Application</span>
    </label>
  </div>
)}

        {/* {!isEditMode && (
          <div className="md:col-span-2 flex items-center gap-4 mt-4 mb-4">
            <label className="text-sm font-medium">Type:</label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={rlsType === "application"}
                onChange={(e) =>{
                  setRlsType(e.target.checked ? "application" : "report")
                  setValue("pipeline", null);
                      setValue("workspace", null);
                      setValue("report", null);
                      setValue("table", null);
                      setValue("field", null);
                      setValue("value", null);
                      setValue("DISTRIBUTION_CLIENT",null)
                      setValue("COMMENTS",null)
                      setValue("LOCATION",null)
                      setValue("USER_NAME",null)
                      setValue("EMAIL",null)
                      setValue("USER_ID",null)
                      setValue("reportTitle",null)
setValue("reportName",null)
                }
                }
              />
              <span>Application</span>
            </label>
          </div>
        )} */}

        <form
          onSubmit={handleSubmit(isEditMode ? onUpdate : onSubmit)}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          <div className="space-y-4">
            {/* Email */}
            <div className="md:col-span-2">
              <label className="block text-sm">
                Email<span className="ml-1 text-red-700">*</span>
              </label>
              <Controller
                name="EMAIL"
                control={control}
                rules={{
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Enter a valid email",
                  },
                }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={rlsType==='report' ? EmailOptions : EmailOptionsforApplication}
                    isSearchable
                    value={
                      field.value
                        ? { label: field.value, value: field.value }
                        : isEditMode && editData?.EMAIL
                        ? { label: editData.EMAIL, value: editData.EMAIL }
                        : null
                    }
                    isDisabled={isEditMode}
                    placeholder="Select Email"
                    id="email"
                    onChange={(val) => {
                      field.onChange(val?.value || "");
                      // setSelectedPipeline(null);
                      // setSelectedReportTitle(null)
                      // setSelectedWorkspace(null);
                      // setSelectedReport(null);
                      // setselectedTable(null);
                      // setSelectedField(null);
                      // setSelectedValue(null);
                      // setValue('reportTitle',null)
                      // setValue("pipeline", null);
                      // setValue("workspace", null);
                      // setValue("report", null);
                      // setValue("table", null);
                      // setValue("field", null);
                      // setValue("value", null);
                    }}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: "200px",
                        overflowY: "auto",
                        scrollbarWidth: "thin",
                      }),
                      menuList: (provided) => ({
                        ...provided,
                        maxHeight: "150px",
                        overflowY: "auto",
                        fontSize: "14px",
                      }),
                      control: (provided) => ({
                        ...provided,
                        minHeight: "40px",
                      }),
                    }}
                  />
                )}
              />
              {errors.EMAIL && (
                <p className="text-red-500 text-xs">{errors.EMAIL.message}</p>
              )}
            </div>
            {/* Report */}
            <div>
              <label className="block sm:text-sm text-[12px] font-medium">
              {
                rlsType==='report'? "Report Title":"Application Title"
              }  
                <span className="ml-1 text-red-700">*</span>
              </label>
              <Controller
                name="reportTitle"
                control={control}
                rules={{
                  required: !isEditMode ? "Report Title is required" : false,
                }}
                render={({ field }) => (
                  <Select
                    id="reportTitle"
                    // options={reportTitles}
                    options={options}
                    value={
                      field.value
                        ? { value: field.value.id, label: field.value.name }
                        : null
                    }
                    onChange={(value) => {
                      const selectedData = value
                        ? { id: value.value, name: value.label }
                        : null;
                      setSelectedReportTitle(selectedData);
                      if (selectedData?.id) {
                        setReportId(selectedData.id);
                      }
                      if (selectedData?.id !== selectedReportTitle?.id) {
                        setSelectedPipeline(null);
                        setSelectedWorkspace(null);
                        setSelectedReport(null);

                        setValue("pipeline", null);
                        setValue("workspace", null);
                        setValue("report", null);
                      }

                      field.onChange(selectedData);
                    }}
                    isDisabled={isEditMode}
                    className="mt-1"
                    isClearable
                    menuPortalTarget={document.body}
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menuList: (provided) => ({
                        ...provided,
                        maxHeight: "150px",
                        overflowY: "auto",
                        fontSize: "14px",
                      }),
                    }}
                  />
                )}
              />
              {errors.reportTitle && (
                <span className="text-red-500 text-sm">
                  {errors.reportTitle.message}
                </span>
              )}
            </div>
            {/* {
              rlsType==='application' &&
            <div>
    <label className="block sm:text-sm text-[12px] font-medium">
      Report Name <span className="ml-1 text-red-700">*</span>
    </label>
    <Controller
      name="reportName" 
      control={control}
      rules={{
        required: !isEditMode ? "Report Name is required" : false,
      }}
      render={({ field }) => (
        <Select
          id="reportName"
          options={options}
          value={
            field.value
              ? { value: field.value.id, label: field.value.name }
              : null
          }
          onChange={(value) => {
            const selectedData = value
              ? { id: value.value, name: value.label }
              : null;
            setSelectedReport(selectedData);

            setValue("reportName", selectedData); // ✅ set form state
            field.onChange(selectedData);
          }}
          isDisabled
          className="mt-1"
          isClearable
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menuList: (provided) => ({
              ...provided,
              maxHeight: "150px",
              overflowY: "auto",
              fontSize: "14px",
            }),
          }}
        />
      )}
    />
    {errors.reportName && (
      <span className="text-red-500 text-sm">
        {errors.reportName.message}
      </span>
    )}
  </div>
            } */}
            {/* Pipeline */}
            {rlsType === "report" && showPipelineWorkspace && (
              <>
                <div>
                  <label
                    htmlFor="pipeline"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Pipeline <span className="ml-1 text-red-700">*</span>
                  </label>
                  <Controller
                    name="pipeline"
                    control={control}
                    // rules={{ required: !isEditMode ? "Pipeline is required" : false }}
                    render={({ field }) => (
                      <Select
                        id="pipeline"
                        options={pipelines}
                        value={
                          field.value
                            ? { value: field.value.id, label: field.value.name }
                            : null
                        }
                        onChange={(value) => {
                          const selectedData = value
                            ? { id: value.value, name: value.label }
                            : null;
                          setSelectedPipeline(selectedData);

                          field.onChange(selectedData);
                        }}
                        isDisabled
                        className="mt-1"
                        isClearable
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                        menuShouldScrollIntoView={false}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menuList: (provided) => ({
                            ...provided,
                            maxHeight: "150px",
                            overflowY: "auto",
                            fontSize: "14px",
                          }),
                        }}
                      />
                    )}
                  />
                  {errors.pipeline && (
                    <span className="text-red-500 text-sm">
                      {errors.pipeline.message}
                    </span>
                  )}
                </div>

                {/* Workspace */}
                <div>
                  <label
                    htmlFor="workspace"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Workspace <span className="ml-1 text-red-700">*</span>
                  </label>
                  <Controller
                    name="workspace"
                    control={control}
                    // rules={{ required: !isEditMode ? "Workspace is required" : false }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        id="workspace"
                        options={workspaces}
                        value={
                          field.value
                            ? { value: field.value.id, label: field.value.name }
                            : null
                        }
                        onChange={(value) => {
                          const selectedData = value
                            ? { id: value.value, name: value.label }
                            : null;
                          setSelectedWorkspace(selectedData);
                          // setSelectedReport(null);
                          // setselectedTable(null);
                          // setSelectedField(null);
                          // setSelectedValue(null);
                          // setValue("report", null);
                          // setValue("table", null);
                          // setValue("field", null);
                          // setValue("value", null);
                          field.onChange(selectedData);
                        }}
                        className="mt-1"
                        isClearable
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                        menuShouldScrollIntoView={false}
                        isDisabled
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menuList: (provided) => ({
                            ...provided,
                            maxHeight: "150px",
                            overflowY: "auto",
                            fontSize: "14px",
                          }),
                        }}
                      />
                    )}
                  />
                  {errors.workspace && (
                    <span className="text-red-500 text-sm">
                      {errors.workspace.message}
                    </span>
                  )}
                </div>

              </>
            )}

                {/* Report */}
                <div>
                  <label
                    htmlFor="report"
                    className="block text-sm font-medium text-gray-700"
                  >
                 {
                  rlsType==='report' ? 'Report':"Application"
                 }    <span className="ml-1 text-red-700">*</span>
                  </label>
                  <Controller
                    name="report"
                    control={control}
                    // rules={{ required: !isEditMode ? "Report is required" : false }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        id="report"
                        options={rlsType==='report' ? workSpaceReports:options}
                        value={
                          field.value
                            ? { value: field.value.id, label: field.value.name }
                            : null
                        }
                        onChange={(value) => {
                          const selectedData = value
                            ? { id: value.value, name: value.label }
                            : null;
                          setSelectedReport(selectedData);
                          // setselectedTable(null);
                          // setSelectedField(null);
                          // setSelectedValue(null);
                          // setValue("table", null);
                          // setValue("field", null);
                          // setValue("value", null);
                          field.onChange(selectedData);
                          if (email && selectedData) {
                            setTimeout(
                              () => checkExisting(email, selectedData),
                              0
                            );
                          }
                        }}
                        className="mt-1"
                        isClearable
                        isDisabled
                        menuPlacement="auto"
                        menuShouldScrollIntoView={false}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menuList: (provided) => ({
                            ...provided,
                            maxHeight: "150px",
                            overflowY: "auto",
                            fontSize: "14px",
                          }),
                        }}
                      />
                    )}
                  />
                  {errors.report && (
                    <span className="text-red-500 text-sm">
                      {errors.report.message}
                    </span>
                  )}
                </div>
            {/* Table */}
            <div>
              <label className="block text-sm">
                Table<span className="ml-1 text-red-700">*</span>
              </label>
              <Controller
                name="table"
                control={control}
                defaultValue={{
                  id: "BIL_BOOKATTRIBUTES",
                  name: "BIL_BOOKATTRIBUTES",
                }}
                // rules={{ required: "Table is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    id="table"
                    isClearable
                    options={tables}
                    // isDisabled={!selectedReport}
                    value={
                      field.value
                        ? {
                            value: field.value.id,
                            label: field.value.name || field.value.id,
                          }
                        : {
                            value: "BIL_BOOKATTRIBUTES",
                            label: "BIL_BOOKATTRIBUTES",
                          } // fallback default
                    }
                    onChange={(value) => {
                      const selectedData = value
                        ? { id: value.value, name: value.label }
                        : null;
                      setselectedTable(selectedData);
                      // setSelectedField(null);
                      // setSelectedValue(null);
                      // setValue("field", null);
                      // setValue("value", null);
                      field.onChange(selectedData);
                    }}
                    isSearchable
                    placeholder="Select Table"
                  />
                )}
              />
              {errors.table && (
                <p className="text-red-500 text-xs">{errors.table.message}</p>
              )}
            </div>

            {/* Field (Column) */}
            <div>
              <label className="block text-sm">
                Field (Column)<span className="ml-1 text-red-700">*</span>
              </label>
              <Controller
                name="field"
                control={control}
                defaultValue={{ id: "GROUP_3", name: "GROUP_3" }}
                // rules={{ required: "Field is required" }}
                render={({ field }) => {
                  const fields = Array.isArray(fieldTable?.column)
                    ? fieldTable.column.map((f) => ({
                        label: f.lable || f.label || f.value || f,
                        value: f.value || f,
                      }))
                    : fieldTable?.column &&
                      typeof fieldTable.column === "object"
                    ? [
                        {
                          label:
                            fieldTable.column.lable ||
                            fieldTable.column.label ||
                            fieldTable.column.value,
                          value: fieldTable.column.value,
                        },
                      ]
                    : [];

                  return (
                    <Select
                      {...field}
                      id="field"
                      isClearable
                      options={fields}
                      // isDisabled={!selectedTable}
                      isSearchable
                      value={
                        field.value
                          ? {
                              value: field.value.id,
                              label: field.value.name || field.value.id,
                            }
                          : { value: "GROUP_3", label: "GROUP_3" } // fallback default
                      }
                      onChange={(value) => {
                        const selectedData = value
                          ? { id: value.value, name: value.label }
                          : null;
                        setSelectedField(selectedData);
                        // setSelectedValue(null);
                        // setValue("value", null);
                        field.onChange(selectedData);
                      }}
                      placeholder="Select Field"
                    />
                  );
                }}
              />
              {errors.field && (
                <p className="text-red-500 text-xs">{errors.field.message}</p>
              )}
            </div>

            {/* Value */}
            <div className="md:col-span-2">
              <label className="block text-sm">
                Value<span className="ml-1 text-red-700">*</span>
              </label>
              <Controller
                name="value"
                control={control}
                rules={{ required: "Value is required" }}
                render={({ field }) => {
                  const currentValueArray = Array.isArray(field.value)
                    ? field.value.map((v) => ({ label: v.name, value: v.id }))
                    : [];

                  return (
                    <Select
                      {...field}
                      options={valueOptions}
                      // isDisabled={!watchedField}
                      isSearchable
                      isMulti
                      isClearable
                      id="value"
                      placeholder="Select Values"
                      value={currentValueArray}
                      onChange={(valuesSel) => {
                        if (!valuesSel) {
                          setSelectedValue([]);
                          field.onChange([]);
                          return;
                        }
                        if (valuesSel.some((v) => v.value === "*")) {
                          const star = { id: "*", name: "*" };
                          setSelectedValue([star]);
                          field.onChange([star]);
                        } else {
                          const selectedData = valuesSel.map((v) => ({
                            id: v.value,
                            name: v.label,
                          }));
                          setSelectedValue(selectedData);
                          field.onChange(selectedData);
                        }
                      }}
                    />
                  );
                }}
              />
              {errors.value && (
                <p className="text-red-500 text-xs">{errors.value.message}</p>
              )}
            </div>
          </div>

          {/* Right column */}
          <div className="space-y-4">
            {/* Distribution Client */}
            <div>
              <label className="block md:text-[14px] text-[12px]">
                Distribution Client<span className="ml-1 text-red-700">*</span>
              </label>
              <input
                type="text"
                id="DISTRIBUTION_CLIENT"
                {...register("DISTRIBUTION_CLIENT", {
                  required: "Distribution Client is required",
                })}
                className="w-full px-1 py-2 border border-gray-300 rounded-md focus:outline-none"
              />
              {errors.DISTRIBUTION_CLIENT && (
                <p className="text-red-500">
                  {errors.DISTRIBUTION_CLIENT.message}
                </p>
              )}
            </div>

            {/* User Name */}
            <div>
              <label className="block md:text-[14px] text-[12px]">
                User Name<span className="ml-1 text-red-700">*</span>
              </label>
              <input
                type="text"
                {...register("USER_NAME", {
                  required: "User Name is required",
                })}
                className="w-full px-1 py-2 border border-gray-300 rounded-md focus:outline-none"
              />
              {errors.USER_NAME && (
                <p className="text-red-500">{errors.USER_NAME.message}</p>
              )}
            </div>

            {/* User ID */}
            <div>
              <label className="block text-sm">User ID</label>
              <input
                type="text"
                readOnly
                {...register("USER_ID")}
                className="w-full px-2 py-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed focus:outline-none"
              />
            </div>

            {/* Location */}
            <div>
              <label className="block md:text-[14px] text-[12px]">
                Location<span className="ml-1 text-red-700">*</span>
              </label>
              <input
                type="text"
                {...register("LOCATION", { required: "Location is required" })}
                className="w-full px-1 py-2 border border-gray-300 rounded-md focus:outline-none"
              />
              {errors.LOCATION && (
                <p className="text-red-500">{errors.LOCATION.message}</p>
              )}
            </div>

            {/* Status */}
            {/* <div>
            <label className="block md:text-[14px] text-[12px]">
              Status<span className="ml-1 text-red-700">*</span>
            </label>
            <select
              {...register("STATUS", { required: "Status is required" })}
              value={watch("STATUS")}
              className="w-full md:text-[14px] text-[12px] px-1 py-2 border border-gray-300 rounded-md focus:outline-none"
              defaultValue="1" 
            >
              <option value="0">0</option>
              <option value="1">1</option> 
            </select>
            {errors.STATUS && <p className="text-red-500">{errors.STATUS.message}</p>}
          </div> */}
            {/* Comments */}
            <div className="w-full mb-2">
              <label className="block text-sm">
                Comments<span className="ml-1 text-red-700">*</span>
              </label>
              <textarea
                {...register("COMMENTS", { required: "Comments are required" })}
                // value={
                //   selectedReport
                //     ? `${selectedReport.name}\n` + (watch("COMMENTS")?.split("\n").slice(1).join("\n") || "")
                //     : watch("COMMENTS") || ""
                // }
                // onChange={(e) => setValue("COMMENTS", e.target.value)}
                className="w-full h-[118px] border border-gray-300 rounded-md resize-none px-2 py-1"
              />
              {errors.COMMENTS && (
                <p className="text-red-500 text-xs">
                  {errors.COMMENTS.message}
                </p>
              )}
            </div>
          </div>

          {/* Submit */}
          <div className="md:col-span-2">
            <button
              type="submit"
              className="w-full px-6 py-2 text-white rounded-md focus:outline-none bg-[#E31c23]"
            >
              {isEditMode ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDataModal;
